import { TerminalUpdateMessage } from '../models/types/terminals-model.types';
import { authFetchGET, authFetchPOST } from '../utils/auth-fetch';

const env = (<any>window).appenv.services.terminals;

export interface PilotInfo
{
    terminalCode: string;
    timeToPilotInSeconds: number|null;
    timeToBerthInSeconds: number|null;
}

export class TerminalsService {
    static async fetchAllTerminalsData() {
        return await authFetchGET(env.scope, `${env.baseurl}/v1/terminals`);
    }

    static async getTerminalLocaltime(terminalId: string, utc: string): Promise<string> {
        const result = await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/timeToLocal/${utc}`);
        return result.convertedTime;
    }

    static async getTerminalLocaltimeBatch(timestampsAndTerminals: Array<{timestamp: String, terminalId: String}>): Promise<string[]>
    {
        const result = await authFetchPOST(env.scope, `${env.baseurl}/v1/terminals/batchTimeToLocal`, timestampsAndTerminals);
        return result.results.map( (x: {inputTime: string, convertedTime: string}) => x.convertedTime );
    }

    static async getUTCFromTerminalLocaltime(terminalId: string, local: string): Promise<string>
    {
        const result = await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/timeToUTC/${local}`);
        return result.convertedTime;
    }

    static async getTerminalPortMemo(terminalId: string) {
        return await authFetchGET(env.scope, `${env.baseurl}/v2/terminals/${terminalId}/portmemo`);
    }

    static async getTerminalPilotInfo(terminalId: string): Promise<PilotInfo> {
        return await authFetchGET(env.scope, `${env.baseurl}/v1/terminals/${terminalId}/pilot`);
    }

    static async createTerminal(terminal: TerminalUpdateMessage)
    {
        const TerminalUpdate = {
            terminalId: terminal.locationId,
            terminal: terminal,
            updated: new Date().toISOString(),
            deleted: false
        }

        const TerminalVesselMessage = {
            terminals: [TerminalUpdate]
        }

        return await authFetchPOST(env.scope, `${env.baseurl}/v1/terminals`, TerminalVesselMessage)
    }
}
